import React from 'react';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'sonner';
import { Printer, Copy, ExternalLink, Home } from 'lucide-react';
import { LOGO, PHONE_NUMBER } from '../../constants/site';

const copyLink = async (url) => {
  try {
    await navigator.clipboard.writeText(url);
    toast.success('Sign-in link copied');
  } catch {
    toast.error('Copy not available', { description: 'Long-press the link below to copy it manually.' });
  }
};

export const QrControls = ({ property, setProperty, signInUrl }) => (
  <div className="print:hidden bg-sand-50 rounded-2xl shadow-lg p-6 space-y-4 border border-stone-200">
    <div className="flex items-center justify-between">
      <h1 className="text-2xl font-serif font-black text-gray-900">Open House QR Code Generator</h1>
      <Link to="/" className="text-sm text-[#143160] underline flex items-center space-x-1" data-testid="qr-home-link"><Home className="w-4 h-4" /><span>Site</span></Link>
    </div>
    <p className="text-sm text-gray-600">Enter the property address, then print this page and place it at the entrance. Guests scan to sign in — every sign-in lands in your leads instantly.</p>
    <input
      data-testid="qr-property-input"
      className="w-full px-4 py-3 rounded-md border-2 border-[#143160]/40 focus:border-gold-400 focus:outline-none text-lg font-semibold"
      placeholder="Property address (e.g., 123 Ocean Blvd, Virginia Beach)"
      value={property}
      onChange={(e) => setProperty(e.target.value)}
    />
    <div className="flex flex-wrap gap-3">
      <button onClick={() => window.print()} data-testid="qr-print-btn" className="inline-flex items-center space-x-2 bg-[#143160] text-white px-5 py-3 rounded-lg font-bold hover:bg-[#1E4A86]"><Printer className="w-4 h-4" /><span>Print Sign</span></button>
      <button onClick={() => copyLink(signInUrl)} data-testid="qr-copy-btn" className="inline-flex items-center space-x-2 bg-gold-400 text-[#143160] px-5 py-3 rounded-lg font-bold hover:bg-gold-300"><Copy className="w-4 h-4" /><span>Copy Link</span></button>
      <a href={signInUrl} target="_blank" rel="noopener noreferrer" data-testid="qr-open-link" className="inline-flex items-center space-x-2 border-2 border-[#143160] text-[#143160] px-5 py-3 rounded-lg font-bold hover:bg-sand-100"><ExternalLink className="w-4 h-4" /><span>Preview Form</span></a>
    </div>
  </div>
);

export const QrPrintSign = ({ property, signInUrl }) => (
  <div className="bg-sand-50 rounded-3xl shadow-2xl border-8 border-[#143160] p-10 text-center space-y-6 print:shadow-none print:border-4" data-testid="qr-print-sign">
    <img src={LOGO} alt="Jess Sells East Coast" className="h-20 mx-auto" />
    <h2 className="text-4xl sm:text-5xl font-serif font-black text-[#143160]">Welcome Home</h2>
    <p className="text-xl font-bold text-gray-700">Please scan to sign in</p>
    {property.trim() && <p className="text-lg font-semibold text-gold-600" data-testid="qr-property-label">{property}</p>}
    <div className="inline-block p-5 bg-sand-50 border-4 border-gold-400 rounded-2xl">
      <QRCodeSVG value={signInUrl} size={260} level="M" fgColor="#143160" data-testid="qr-code-svg" />
    </div>
    <p className="text-sm text-gray-500 break-all" data-testid="qr-sign-in-url">{signInUrl}</p>
    <div className="pt-4 border-t-2 border-gold-400/40">
      <p className="text-2xl font-cursive font-bold text-[#143160]">Jessica Burnette</p>
      <p className="text-sm font-semibold text-gray-600">REALTOR® | MRP® · {PHONE_NUMBER}</p>
    </div>
  </div>
);
